module.exports = __webpack_public_path__ + "assets/img/favicon/favicon-16x16.7cbc6675813ef25662e49e20009741ec.png";